export default __webpack_public_path__ + "5896bc45dd9e7ee7842045af6cc0aefe.otf";